import { render, staticRenderFns } from "./StyleCollapseControl.vue?vue&type=template&id=0540ad55&scoped=true&"
import script from "./StyleCollapseControl.vue?vue&type=script&lang=js&"
export * from "./StyleCollapseControl.vue?vue&type=script&lang=js&"
import style0 from "./StyleCollapseControl.vue?vue&type=style&index=0&id=0540ad55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540ad55",
  null
  
)

export default component.exports